<template>
  <basic-container>
    <avue-crud :option="option"
               :table-loading="loading"
               :data="data"
               :page.sync="page"
               :permission="permissionList"
               :before-open="beforeOpen"
               v-model="form"
               ref="crud"
               @row-update="rowUpdate"
               @row-save="rowSave"
               @row-del="rowDel"
               @search-change="searchChange"
               @search-reset="searchReset"
               @selection-change="selectionChange"
               @current-change="currentChange"
               @size-change="sizeChange"
               @refresh-change="onLoad"
               @on-load="onLoad">
      <template slot-scope="scope" slot="parkingLotIdSearch">
        <selectSearch  v-model="parkingLotId" :dicData="spaceList" @change="parkingLotQueryChanged"></selectSearch>
        <!-- <el-select
          v-model="parkingLotId"
          filterable
          @change="parkingLotQueryChanged"
          style="width: 100%;"
          placeholder="车场名称"
        >
          <el-option
            v-for="item in spaceList"
            :key="item.id"
            :label="item.title"
            :value="item.id"
          >
          </el-option>
        </el-select> -->
      </template>
      <template slot-scope="scope" slot="shopIdSearch">
        <el-select
          v-model="shopId"
          filterable
          style="width: 100%;"
          placeholder="商家名称"
          clearable="true"
        >
          <el-option
            v-for="item in shopList"
            :key="item.id"
            :label="item.shopName"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </template>
      <template slot-scope="scope" slot="useTimeRangeSearch">
        <el-date-picker
          v-model="useTimeRange"
          type="datetimerange"
          value-format="yyyy-MM-dd HH:mm:ss"
          start-placeholder="开始时间"
          end-placeholder="结束时间"
          >
        </el-date-picker>
      </template>
      <template slot-scope="scope" slot="totalDiscountAmountSearch" id="totalDiscountAmount">
        <el-input v-model="totalDiscountAmount" disabled="true" placeholder="0"></el-input>
      </template>
      <template slot="menuLeft">
        <el-button type="danger"
                   size="small"
                   icon="el-icon-delete"
                   plain
                   v-if="permission.carcouponused_delete"
                   @click="handleDelete">删 除
        </el-button>
      </template>
    </avue-crud>
  </basic-container>
</template>

<script>
  import { add, getDetail, getList, remove, update,getDiscountAmount } from '@/api/v4ward/park/coupon/used/carcouponused';
  import { getSpaceTree } from '@/api/v4ward/car/carparkspace';
  import { shopList } from '@/api/v4ward/park/coupon/shop/carcouponshop';
  import func from '@/util/func';
  import { mapGetters } from 'vuex';

  export default {
    data() {
      return {
        form: {},
        query: {},
        loading: true,
        page: {
          pageSize: 10,
          currentPage: 1,
          total: 0,
        },
        selectionList: [],
        option: {
          height: 'auto',
          calcHeight: 30,
          tip: false,
          searchShow: true,
          searchMenuSpan: 6,
          border: true,
          index: true,
          viewBtn: true,
          selection: false,
          dialogClickModal: false,
          menu: false,
          columnBtn: true,
          refreshBtn: true,
          emptyBtn: false,
          stripe:true,
          column: [
            {
              label: '车场名称',
              prop: 'parkingLotId',
              type: 'select',
              overHidden: true,
              search: true,
              searchSpan: 6,
              searchslot: true,
              dicData: [],
              width: 150,
              props: {
                label: 'title',
                value: 'id',
                disabled: 'disabled',
              },
              rules: [{
                required: true,
                message: '请选择车场名称',
                trigger: 'change',
              }],
            },
            {
              label: '商家名称',
              prop: 'shopId',
              hide: true,
              showColumn:false,
              type: 'select',
              display: false,
              searchSpan: 6,
              search: true,
              searchslot: true,
              rules: [{
                required: true,
                message: '请输入结算商家id',
                trigger: 'change',
              }],
            },
            {
              label: '商家名称',
              prop: 'shopName',
              overHidden: true,
              width: 150,
            },
            {
              label: '使用时间',
              prop: 'useTimeRange',
              search: true,
              searchSpan: 12,
              searchslot: true,
              hide: true,
               showColumn:false,
              display: false,
            },
            {
              label: '优惠券',
              prop: 'couponName',
              width: 150,
              overHidden: true,
              search: true,
              searchSpan: 6,
            },
            {
              label: '车牌号',
              prop: 'plateNumber',
              search: true,
              searchSpan: 6,
              width: 76,
            },
            {
              label: '优惠金额',
              prop: 'totalDiscountAmount',
              search: true,
              searchslot: true,
              searchSpan: 6,
              hide: true,
               showColumn:false,
              display: false,
            },
            {
              label: '使用时间',
              prop: 'couponUsedTime',
              width: 136,
              rules: [{
                required: true,
                message: '请输入优惠券使用时间',
                trigger: 'change',
              }],
            },
            {
              label: '优惠金额',
              prop: 'discountAmount',
              width: 72,
            },
            {
              label: '支付信息',
              prop: 'payInfo',
              overHidden: true,
            },
          ],
        },
        data: [],
        spaceList: [],
        shopList: [],
        shopId: '',
        parkingLotId: '',
        firstDisplayFlag: true,
        useTimeRange: '',
        totalDiscountAmount: 0,
      };
    },
    created() {
      this.option.height = this.bodyHeight - 380;
      this.initTimeRange();
      getSpaceTree().then((data) => {
        this.spaceList = data.data;
        if (this.spaceList.length > 0) {
          var spaceColumn = this.findObject(this.option.column, 'parkingLotId');
          spaceColumn.dicData = data.data;
          spaceColumn.searchValue = this.spaceList[0].id;
          // 默认查询第一个
          this.parkingLotId = this.spaceList[0].id;
          this.initShopList(this.parkingLotId);
          this.$nextTick(() => {
            this.reWrite = true;
          });
        } else {
          this.$nextTick(() => {
            this.reWrite = true;
          });
        }
      });
    },
    mounted(){
      this.$nextTick(() => {
      setTimeout(()=>{
              document.querySelector('#avue-view  div.avue-crud > div.avue-crud__menu > div.avue-crud__right > button:nth-child(3)').addEventListener("click", ()=>{

                      if(this.option.height == this.bodyHeight - 380){
                      this.option.height = this.bodyHeight - 280
                      }else{
                      this.option.height = this.bodyHeight - 380;
                      }
                      this.$refs.crud.getTableHeight();
              });
              },1000)

      });
    },
    activated() {
      let self = this;
      setTimeout(() => {
        this.$refs.crud.doLayout(); //解决表格错位
      }, 0);
    },
    computed: {
      ...mapGetters(['permission']),
      permissionList() {
        return {
          addBtn: this.vaildData(this.permission.carcouponused_add, false),
          viewBtn: this.vaildData(this.permission.carcouponused_view, false),
          delBtn: this.vaildData(this.permission.carcouponused_delete, false),
          editBtn: this.vaildData(this.permission.carcouponused_edit, false),
        };
      },
      ids() {
        let ids = [];
        this.selectionList.forEach(ele => {
          ids.push(ele.id);
        });
        return ids.join(',');
      },
    },
    methods: {
      initTimeRange() {
        var startTime = func.getCurrentMonthFirst() + ' 00:00:00';
        var endTime = func.getCurrentMonthLast() + ' 23:59:59';
        this.useTimeRange = [startTime, endTime];
      },
      initShopList(parkingLotId) {
        shopList({ parkingLotId: parkingLotId ,byShopUser:1}).then((data) => {
          this.shopList = data.data;
          if (this.shopList.length > 0) {
            var shopColumn = this.findObject(this.option.column, 'shopId');
            //shopColumn.searchValue = this.shopList[0].id;
            this.shopId = this.shopList[0].id;
            this.onLoad();
            this.$nextTick(() => {
              this.reWrite = true;
            });
          } else {
            this.shopId = '';
            this.onLoad();
            this.$nextTick(() => {
              this.reWrite = true;
            });
          }
        });
      },
      parkingLotQueryChanged(value) {
        this.initShopList(value);
      },
      rowSave(row, done, loading) {
        add(row).then(() => {
          this.onLoad();
          this.$message.success('操作成功!');
          done();
        }, error => {
          window.console.log(error);
          loading();
        });
      },
      rowUpdate(row, index, done, loading) {
        update(row).then(() => {
          this.onLoad();
          this.$message.success('操作成功!');
          done();
        }, error => {
          window.console.log(error);
          loading();
        });
      },
      rowDel(row) {
        this.$confirm('确定将选择数据删除?', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(() => {
            return remove({ ids: row.id });
          })
          .then(() => {
            this.onLoad();
            this.$message.success('操作成功!');
          });
      },
      handleDelete() {
        if (this.selectionList.length === 0) {
          this.$message.warning('请选择至少一条数据');
          return;
        }
        this.$confirm('确定将选择数据删除?', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(() => {
            return remove({ ids: this.ids });
          })
          .then(() => {
            this.onLoad();
            this.$message.success('操作成功!');
            this.$refs.crud.toggleSelection();
          });
      },
      beforeOpen(done, type) {
        if (['edit', 'view'].includes(type)) {
          getDetail({ id: this.form.id }).then(({ data }) => {
            this.form = data;
          });
        } else if ('add' === type) {
          this.cleanForm();
        }
        done();
      },
      cleanForm() {
        for (let key in this.form) {
          this.form[key] = null;
        }
      },
      searchReset() {
        this.query = {};
        this.onLoad();
      },
      searchChange(params, done) {
        this.query = params;
        this.page.currentPage = 1;
        this.onLoad();
        done();
      },
      selectionChange(list) {
        this.selectionList = list;
      },
      selectionClear() {
        this.selectionList = [];
        this.$refs.crud.toggleSelection();
      },
      currentChange(currentPage) {
        this.page.currentPage = currentPage;
      },
      sizeChange(pageSize) {
        this.page.pageSize = pageSize;
      },
      onLoad(page) {
        this.loading = false;
        page = page || this.page;
        this.query.parkingLotId = this.parkingLotId;
        if(this.vdui.isEmpty(this.query.parkingLotId)){
          return;
        }
        this.loading = true;
        if(this.useTimeRange){
          this.query.useTimeRange = this.useTimeRange[0] + ',' + this.useTimeRange[1];
        }
        this.query.shopId = null;
        if(this.vdui.isNotEmpty(this.shopId)){
          this.query.shopId = this.shopId;
        }
        if(this.vdui.isNotEmpty(this.query.plateNumber)){
          this.query.plateNumber = this.query.plateNumber.trim().replace(' ','');
        }
        getList(
          Object.assign({ current: page.currentPage, size: page.pageSize }, this.query),
        ).then(({ data }) => {
          this.page.total = data.total;
          this.data = data.records;
          this.loading = false;
          this.selectionClear();

          if (this.firstDisplayFlag) {
            let ent = document.querySelector('input[placeholder="车场名称"]');
            ent.value = this.spaceList[0].title;
            this.query.parkingLotId = this.spaceList[0].id;
            this.firstDisplayFlag = false;
          }
        });
        getDiscountAmount(Object.assign({ current: page.currentPage, size: page.pageSize }, this.query))
          .then(({data}) => {
            this.totalDiscountAmount = data;
          })
      },
    },
  };
</script>
<style scoped>

  ::v-deep .avue-form__menu--center{
    text-align: right;
  }
::v-deep   .avue-crud__search .el-form-item--small.el-form-item{
    width: 100%;
  }
</style>
